module.exports = __webpack_public_path__ + "img/congrats.b702990c.svg";